var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spinner spinner-origami", style: _vm.styles },
    [
      _c(
        "div",
        { staticClass: "spinner-inner loading", style: _vm.innerStyles },
        [
          _c("span", { staticClass: "slice" }),
          _vm._v(" "),
          _c("span", { staticClass: "slice" }),
          _vm._v(" "),
          _c("span", { staticClass: "slice" }),
          _vm._v(" "),
          _c("span", { staticClass: "slice" }),
          _vm._v(" "),
          _c("span", { staticClass: "slice" }),
          _vm._v(" "),
          _c("span", { staticClass: "slice" })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7be6aba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7be6aba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Origami.vue
// module id = KKeh
// module chunks = 0